module.exports = __webpack_public_path__ + "static/media/customer-g20.a6b449a3.png";